const iconFactory = () => (
  <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.8388 7.648L19.6875 12.7858V8.82311C19.6875 7.72531 18.4611 7.05888 17.5263 7.648L9.375 12.7858V1.39286C9.375 0.623594 8.74541 0 7.96875 0H1.40625C0.62959 0 0 0.623594 0 1.39286V24.6071C0 25.3764 0.62959 26 1.40625 26H28.5938C29.3704 26 30 25.3764 30 24.6071V8.82311C30 7.72525 28.7736 7.05888 27.8388 7.648Z" fill="#001F5C"/>
  </svg>
);
export default iconFactory